/* eslint-disable react/jsx-props-no-spreading */
import { type GoogleMapPinProps } from '../LocationListingHelpers';
import DuotoneIcon from '2-core-elements/Icon/DuotoneIcon';

interface ItemPinProps extends GoogleMapPinProps {
    onClick?: () => void;
    isActive?: boolean;
}


const ItemPin = ({ onClick, isActive = false, style }: ItemPinProps): JSX. Element => {
    const skin = '1';

    return (
        <button
            type="button"
            className={`item-pin ${skin} ${isActive ? 'is-active' : ''}`}
            onClick={onClick}
            style={style}

        >
            <div className="item-pin-loader">
                <div className="item-pin-loader-anim">
                    <div className="item-pin-loader-item" />
                    <div className="item-pin-loader-item" />
                </div>
            </div>
            <DuotoneIcon icon="map" />
        </button>
    );
};

export default ItemPin;
